// removed by extract-text-webpack-plugin
module.exports = {"modal":"modal___359og","modalContent":"modalContent___25-gM","modalFooter":"modalFooter___3VUXl","button":"button___2gBvB","hidden":"hidden___2MUYK"};


//////////////////
// WEBPACK FOOTER
// /app/js/components/Modal/styles.scss
// module id = 478
// module chunks = 0